export const _successfulGrow_failGrow_interval_ms = 1500

export const _paginationPageSizeOptions = [
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
]

export const _clientVersion = '1.2.0'
